type Enum = Record<string | number, string | number>

export const isEnum = (value: string, enumType: Enum) => {
  return (
    Object.values(enumType).includes(value as any) ||
    Object.keys(enumType).includes(value as any)
  );
}

export const getEnumValue = (enumKey: string, enumType: Enum) => {
  return Object.entries(enumType).find(([key]) => key === enumKey)?.[1] as any
}

